






































































































































































































































































































































import FormInputCount from '@/components/molecules/formInputCount/FormInputCount.vue';
import FormInputText from '@/components/atoms/formInputText/FormInputText.vue';
import FormField from '@/components/molecules/formField/FormField.vue';
import FormFileUpload from '@/components/molecules/formFileUpload/FormFileUpload.vue';
import FormSelect from '@/components/molecules/formSelect/FormSelect.vue';
import FunctionalityButton, {
    FunctionalityButtonValueType,
} from '@/components/molecules/functionalityButton/FunctionalityButton.vue';
import { getFormInputMixin } from '@/mixins/formInputMixin';
import { ValidationsCommonType } from '@/services/form/validations';
import { GeneratorModuleFormGroup } from '@/types/forms/formGroups/plantPerformance/generator/generatorModuleFormGroup';
import { GeneratorModuleFormGroupContent } from '@/api/interfaces/content/form/steps/plantPerformance/generatorContent';
import { number } from '@/validators/number';
import {
    formatGermanNumber,
    parseGermanFloat,
} from '@/utilities/germanFormats';
import { interpolate } from '@/services/interpolationService';
import FormTextBlock from '@/components/molecules/formTextBlock/FormTextBlock.vue';
import { roundToDecimals } from '@/utilities/math';
import FormBooleanCheckbox from '@/components/molecules/formBooleanCheckbox/FormBooleanCheckbox.vue';
import { GeneratorDataContentSearchByZerezId } from '@/api/interfaces/content/form/serviceDriven/generatorDataContentSearchByZerezId';
import { GeneratorDataContent } from '@/api/interfaces/content/form/serviceDriven/generatorDataContent';
import { contentServices } from '@/services/contentService';
import { isGeneratorDataContentSearchByManufacturerAndModuleType } from '@/api/interfaces/typeGuards';
import { ConnectionRulesType } from '@/types/forms/shared/connectionRulesType';
import { enumsContent } from '@/api/mock/content/app/enumsContent';
import { camelCase } from 'lodash';
import { EntryListContent } from '@/api/interfaces/content/common/entryListContent';
import { GeneratorDataContentSearchByManufacturerAndModuleType } from '@/api/interfaces/content/form/serviceDriven/generatorDataContentSearchByManufacturerAndModuleType';
import { appState } from '@/services/form/appState';

export default getFormInputMixin<
    GeneratorModuleFormGroup,
    GeneratorModuleFormGroupContent
>().extend({
    name: 'GeneratorModuleFormGroup',
    components: {
        FormInputCount,
        FormInputText,
        FormField,
        FormFileUpload,
        FormSelect,
        FunctionalityButton,
        FormTextBlock,
        FormBooleanCheckbox,
    },
    props: {
        applicationId: {
            type: String,
            required: true,
        },
        showRemoveButton: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            functionalityButtonValue: 'remove' as FunctionalityButtonValueType,
        };
    },
    computed: {
        generatorManufacturerAndModuleTypeValidations():
            | ValidationsCommonType
            | unknown {
            return this.validations?.generatorManufacturerAndModuleType || {};
        },
        generatorZerezIdAndNormValidations(): ValidationsCommonType | unknown {
            return this.validations?.generatorZerezIdAndNorm || {};
        },
        generatorQuantityAndGeneratorTypeValidations():
            | ValidationsCommonType
            | unknown {
            return this.validations?.generatorQuantityAndGeneratorType || {};
        },
        generatorActivePowerAndApparentPowerValidations():
            | ValidationsCommonType
            | unknown {
            return this.validations?.generatorActivePowerAndApparentPower || {};
        },
        totalActivePowerDisplayValue(): string {
            return interpolate(this.content.generatorTotalActivePower.unit, {
                value: formatGermanNumber(
                    this.model.generatorTotalActivePower.value ?? 0,
                    {
                        decimals: 2,
                        thousandsSeparator: true,
                    },
                ),
            });
        },
        totalApparentPowerDisplayValue(): string {
            return interpolate(this.content.generatorTotalApparentPower.unit, {
                value: formatGermanNumber(
                    this.model.generatorTotalApparentPower.value ?? 0,
                    {
                        decimals: 2,
                        thousandsSeparator: true,
                    },
                ),
            });
        },
        generatorManualInputManufacturerTypeZerezId() {
            return (
                this.model.generatorManualInputManufacturerTypeZerezId.value ??
                false
            );
        },
    },
    watch: {
        'model.generatorQuantityAndGeneratorType.quantity.value': {
            handler(newValue: number | null) {
                this.model.generatorTotalActivePower.value = this.getTotalPower(
                    newValue,
                    this.model.generatorActivePowerAndApparentPower.activePower
                        .value,
                );

                this.model.generatorTotalApparentPower.value = this.getTotalPower(
                    newValue,
                    this.model.generatorActivePowerAndApparentPower
                        .apparentPower.value,
                );
            },
            immediate: true,
        },
        'model.generatorActivePowerAndApparentPower.activePower.value': {
            handler(newValue: string | null) {
                this.model.generatorTotalActivePower.value = this.getTotalPower(
                    this.model.generatorQuantityAndGeneratorType.quantity.value,
                    newValue,
                );
            },
            immediate: true,
        },
        'model.generatorActivePowerAndApparentPower.apparentPower.value': {
            handler(newValue: string | null) {
                this.model.generatorTotalApparentPower.value = this.getTotalPower(
                    this.model.generatorQuantityAndGeneratorType.quantity.value,
                    newValue,
                );
            },
            immediate: true,
        },
        'model.generatorManufacturerAndModuleType.manufacturerText.value': {
            handler(newValue: string | null) {
                // On any sort of interaction, sync to backing field
                this.model.generatorManufacturerAndModuleType.manufacturer.value = newValue;
            },
            immediate: false,
        },
        'model.generatorManufacturerAndModuleType.manufacturerSelect.value': {
            handler(newValue: string | null, oldValue: string | null): void {
                // On any sort of interaction, sync to backing field
                this.model.generatorManufacturerAndModuleType.manufacturer.value = newValue;

                // If value didn't change, there is nothing that has to be done
                if (newValue === oldValue) {
                    return;
                }

                // If new value is empty, then this field shouldn't cause changes to ay other fields,
                // except for the aforementioned backing field
                if (!newValue) {
                    return;
                }

                // That's where we end, if the manufacturer name hasn't been set already
                if (
                    !this.model.generatorManufacturerAndModuleType
                        .moduleTypeSelect.value
                ) {
                    return;
                }

                // However, if both are available, try searching for an generator for auto pre-fill,
                // clearing the other fields, if no match could be found
                const generator = this.getGenerator({
                    manufacturerName: newValue,
                    moduleType: this.model.generatorManufacturerAndModuleType
                        .moduleTypeSelect.value,
                });
                if (generator === undefined) {
                    this.model.generatorManufacturerAndModuleType.moduleTypeSelect.value = null;
                    this.model.generatorZerezIdAndNorm.zerezId.value = null;
                    this.model.generatorZerezIdAndNorm.norm.value = null;
                    this.model.generatorActivePowerAndApparentPower.activePower.value = null;
                    this.model.generatorActivePowerAndApparentPower.apparentPower.value = null;
                    return;
                }

                this.updateGeneratorFields(generator);
            },
            immediate: false,
        },
        'model.generatorManufacturerAndModuleType.moduleTypeText.value': {
            handler(newValue: string | null) {
                // On any sort of interaction, sync to backing field
                this.model.generatorManufacturerAndModuleType.moduleType.value = newValue;
            },
            immediate: false,
        },
        'model.generatorManufacturerAndModuleType.moduleTypeSelect.value': {
            handler(newValue: string | null, oldValue: string | null): void {
                // On any sort of interaction, sync to backing field
                this.model.generatorManufacturerAndModuleType.moduleType.value = newValue;

                // If value didn't change, there is nothing that has to be done
                if (newValue === oldValue) {
                    return;
                }

                // If new value is empty, then this field shouldn't cause changes to ay other fields,
                // except for the aforementioned backing field
                if (!newValue) {
                    return;
                }

                // That's where we end, if the manufacturer name hasn't been set already
                if (
                    !this.model.generatorManufacturerAndModuleType
                        .manufacturerSelect.value
                ) {
                    return;
                }

                // However, if both are available, try searching for an generator for auto pre-fill,
                // clearing the other fields, if no match could be found
                const generator = this.getGenerator({
                    manufacturerName: this.model
                        .generatorManufacturerAndModuleType.manufacturerSelect
                        .value,
                    moduleType: newValue,
                });
                if (generator === undefined) {
                    this.model.generatorManufacturerAndModuleType.manufacturerSelect.value = null;
                    this.model.generatorZerezIdAndNorm.zerezId.value = null;
                    this.model.generatorZerezIdAndNorm.norm.value = null;
                    this.model.generatorActivePowerAndApparentPower.activePower.value = null;
                    this.model.generatorActivePowerAndApparentPower.apparentPower.value = null;
                    return;
                }

                this.updateGeneratorFields(generator);
            },
            immediate: false,
        },
        'model.generatorZerezIdAndNorm.zerezId.value': {
            handler(newValue: string | null, oldValue: string | null): void {
                // On any sort of interaction, sync to backing field
                this.model.generatorZerezIdAndNorm.zerezId.value = newValue;

                // If value didn't change, there is nothing that has to be done
                if (newValue === oldValue) {
                    return;
                }

                // If new value is empty, then do not cause a watcher loop
                if (!newValue) {
                    return;
                }

                // However, if both are available, try searching for an generator for auto pre-fill,
                // clearing the other fields, if no match could be found
                const generator = this.getGenerator({
                    zerezId: newValue,
                });
                if (generator === undefined) {
                    this.model.generatorManufacturerAndModuleType.manufacturerSelect.value = null;
                    this.model.generatorManufacturerAndModuleType.moduleTypeSelect.value = null;
                    this.model.generatorZerezIdAndNorm.norm.value = null;
                    this.model.generatorActivePowerAndApparentPower.activePower.value = null;
                    this.model.generatorActivePowerAndApparentPower.apparentPower.value = null;
                    return;
                }

                this.updateGeneratorFields(generator);
            },
            immediate: false,
        },
        'model.generatorZerezIdAndNorm.norm.value': {
            handler(newValue: ConnectionRulesType[]) {
                if (!newValue) {
                    this.model.generatorZerezIdAndNorm.normText.value = null;
                    return;
                }

                const translated = newValue.map(
                    (value) =>
                        (enumsContent.connectionRulesType as EntryListContent)[
                            camelCase(value)
                        ],
                ) as string[];
                this.model.generatorZerezIdAndNorm.normText.value = translated.join(
                    ', ',
                );
            },
            immediate: true,
        },
        // If the displayed fields are toggled, set the backing fields to the values of the now shown fields and possibly clear irrelevant fields
        generatorManualInputManufacturerTypeZerezId: {
            handler(newValue: boolean) {
                if (appState.debugFillInProgress) {
                    return;
                }

                // Update backing fields and possibly other fields based on which fields are displayed
                if (newValue) {
                    this.model.generatorManufacturerAndModuleType.manufacturer.value = this.model.generatorManufacturerAndModuleType.manufacturerText.value;
                    this.model.generatorManufacturerAndModuleType.moduleType.value = this.model.generatorManufacturerAndModuleType.moduleTypeText.value;
                    this.model.generatorZerezIdAndNorm.zerezId.value = null;
                    this.model.generatorZerezIdAndNorm.norm.value = null;
                    this.model.generatorActivePowerAndApparentPower.activePower.value = null;
                    this.model.generatorActivePowerAndApparentPower.apparentPower.value = null;
                } else {
                    this.model.generatorManufacturerAndModuleType.manufacturer.value = this.model.generatorManufacturerAndModuleType.manufacturerSelect.value;
                    this.model.generatorManufacturerAndModuleType.moduleType.value = this.model.generatorManufacturerAndModuleType.moduleTypeSelect.value;

                    // Reset norm field, if zerez id is not filled
                    if (
                        this.model.generatorZerezIdAndNorm.zerezId.value ===
                        null
                    ) {
                        this.model.generatorZerezIdAndNorm.norm.value = null;
                    }

                    // Check currently filled fields, to possibly immediately prefill fields back up again (e.g. someone checked the box, which clears zerez id and norm, and immediately unchecks it again)
                    if (this.model.generatorZerezIdAndNorm.zerezId.value) {
                        const generator = this.getGenerator({
                            zerezId: this.model.generatorZerezIdAndNorm.zerezId
                                .value,
                        });
                        if (generator) {
                            this.updateGeneratorFields(generator);
                        }
                    } else if (
                        this.model.generatorManufacturerAndModuleType
                            .manufacturerSelect.value &&
                        this.model.generatorManufacturerAndModuleType
                            .moduleTypeSelect.value
                    ) {
                        const generator = this.getGenerator({
                            manufacturerName: this.model
                                .generatorManufacturerAndModuleType
                                .manufacturerSelect.value,
                            moduleType: this.model
                                .generatorManufacturerAndModuleType
                                .moduleTypeSelect.value,
                        });
                        if (generator) {
                            this.updateGeneratorFields(generator);
                        }
                    }
                }
            },
            immediate: false,
        },
    },
    created() {
        if (this.generatorManualInputManufacturerTypeZerezId) {
            this.model.generatorManufacturerAndModuleType.manufacturerText.value = this.model.generatorManufacturerAndModuleType.manufacturer.value;
            this.model.generatorManufacturerAndModuleType.moduleTypeText.value = this.model.generatorManufacturerAndModuleType.moduleType.value;
            this.model.generatorZerezIdAndNorm.zerezId.value = null;
        } else {
            this.model.generatorManufacturerAndModuleType.manufacturerSelect.value = this.model.generatorManufacturerAndModuleType.manufacturer.value;
            this.model.generatorManufacturerAndModuleType.moduleTypeSelect.value = this.model.generatorManufacturerAndModuleType.moduleType.value;
        }
    },
    methods: {
        getTotalPower(
            rawQuantity: number | null,
            rawPower: string | null,
        ): number {
            // power as number; default: 0
            let power = 0;
            if (rawPower != null) {
                const parsedPower = parseGermanFloat(rawPower);
                power = number(parsedPower) ? parsedPower : 0;
            }

            // quantity as number; default: 0
            let quantity = 0;
            if (rawQuantity != null) {
                quantity = number(rawQuantity) ? rawQuantity : 0;
            }

            return roundToDecimals(quantity * power);
        },
        getGenerator(
            search:
                | GeneratorDataContentSearchByManufacturerAndModuleType
                | GeneratorDataContentSearchByZerezId,
        ): GeneratorDataContent | undefined {
            const content = contentServices.form.content;
            if (!content) {
                return undefined;
            }

            const generatorsContent =
                content?.serviceDrivenContent?.generatorsContent;
            if (!generatorsContent) {
                return undefined;
            }

            if (
                isGeneratorDataContentSearchByManufacturerAndModuleType(search)
            ) {
                return generatorsContent.find(
                    (generator) =>
                        generator.manufacturerName ===
                            search.manufacturerName &&
                        generator.moduleType === search.moduleType,
                );
            } else {
                return generatorsContent.find(
                    (generator) => generator.zerezId === search.zerezId,
                );
            }
        },
        /**
         * Updates all fields included in the generator, based on which ones are currently displayed.
         * Also, only updates values that have actually changed, to avoid potentially triggering watchers unintentionally
         * @param generator
         */
        updateGeneratorFields(generator: GeneratorDataContent) {
            const showingDropdownFields =
                this.model.generatorManualInputManufacturerTypeZerezId
                    .disabled ||
                !this.model.generatorManualInputManufacturerTypeZerezId.value;

            // Manufacturer Name
            if (
                generator.manufacturerName !==
                this.model.generatorManufacturerAndModuleType.manufacturer.value
            ) {
                if (showingDropdownFields) {
                    this.model.generatorManufacturerAndModuleType.manufacturerSelect.value =
                        generator.manufacturerName;
                } else {
                    this.model.generatorManufacturerAndModuleType.manufacturerText.value =
                        generator.manufacturerName;
                }
            }

            // Manufacturer Module Type
            if (
                generator.moduleType !==
                this.model.generatorManufacturerAndModuleType.moduleType.value
            ) {
                if (showingDropdownFields) {
                    this.model.generatorManufacturerAndModuleType.moduleTypeSelect.value =
                        generator.moduleType;
                } else {
                    this.model.generatorManufacturerAndModuleType.moduleTypeText.value =
                        generator.moduleType;
                }
            }

            // Zerez Id
            if (
                generator.zerezId !==
                this.model.generatorZerezIdAndNorm.zerezId.value
            ) {
                this.model.generatorZerezIdAndNorm.zerezId.value =
                    generator.zerezId;
            }

            // Norm
            if (
                generator.connectionRulesTypes !==
                this.model.generatorZerezIdAndNorm.norm.value
            ) {
                this.model.generatorZerezIdAndNorm.norm.value =
                    generator.connectionRulesTypes;
            }

            // Active Power
            const parsedActivePower = formatGermanNumber(
                generator.activePower,
                {
                    decimals: 2,
                    thousandsSeparator: true,
                },
            );
            if (
                parsedActivePower !==
                this.model.generatorActivePowerAndApparentPower.activePower
                    .value
            ) {
                this.model.generatorActivePowerAndApparentPower.activePower.value = parsedActivePower;
            }

            // Apparent Power
            const parsedApparentPower = formatGermanNumber(
                generator.apparentPower,
                { decimals: 2, thousandsSeparator: true },
            );
            if (
                parsedApparentPower !==
                this.model.generatorActivePowerAndApparentPower.apparentPower
                    .value
            ) {
                this.model.generatorActivePowerAndApparentPower.apparentPower.value = parsedApparentPower;
            }
        },
    },
});
